import {
    IRef,
} from './types';

import {
    useDefaultedRef,
} from 'tools/hooks';

export function useNumberInputRef() {
    return useDefaultedRef<IRef>({
        setValue(): void {
            return;
        },
    });
}
